import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import StopLineupsGeneration from 'components/molecules/stop-lineups-generation';

class Preloader extends Component {
    render() {
        const {rawLineups, lineups} = this.props;

        if (!lineups.loading) {
            return null;
        }

        return (
            <div className="players-heading">
                <strong>{rawLineups.getQuantity()}</strong> Lineups
                <StopLineupsGeneration />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {rawLineups, lineups} = state.lineupsData;

    return {
        rawLineups,
        lineups,
    };
}

export default connect(mapStatesToProps)(Preloader);
